import { QueryClientProvider } from '@tanstack/react-query'
import { Direction } from 'radix-ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { Toaster } from 'sonner'

import { App } from './App'
import { routerBase } from './lib/base-path'
import { createQueryClient } from './lib/queries'
import { applyMode, preferredMode } from './lib/theme-mode'
import './styles/theme.css'

const container = document.querySelector('#root')
if (container === null) {
  throw new Error('عنصر ریشه پیدا نشد.')
}

// پیش از نخستین رندر اعمال می‌شود، وگرنه کاربرِ حالت تاریک یک لحظه صفحه‌ی
// سفید می‌بیند.
applyMode(preferredMode())

const queryClient = createQueryClient()

createRoot(container).render(
  <StrictMode>
    {/*
      `DirectionProvider` جهت را به اجزای Radix اعلام می‌کند. بدون آن، منوها و
      select در جهت راست‌به‌چپ، سمت اشتباه باز می‌شوند و ناوبری کیبورد با
      کلیدهای جهت‌دار برعکس کار می‌کند.
    */}
    <Direction.DirectionProvider dir="rtl">
      <QueryClientProvider client={queryClient}>
        {/*
          `basename` شامل مسیر عمومی نسخه‌ی مشتری است (`/acme`)، تا مسیرهای
          داخلی مثل `/archive` زیر همان نسخه بمانند و رفرش صفحه نشکند.
        */}
        <BrowserRouter basename={routerBase()}>
          <App />
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          dir="rtl"
          // رنگ‌ها از توکن‌های خود پروژه می‌آیند، نه پالت پیش‌فرض sonner؛
          // وگرنه در حالت تاریک، toast روشن روی صفحه‌ی تیره می‌نشست.
          toastOptions={{
            style: {
              fontFamily: 'inherit',
              background: 'var(--color-surface-raised)',
              color: 'var(--color-ink)',
              border: '1px solid var(--color-line)',
              borderRadius: 'var(--radius-md)',
              boxShadow: 'var(--shadow-overlay)',
            },
          }}
          closeButton
        />
      </QueryClientProvider>
    </Direction.DirectionProvider>
  </StrictMode>,
)
